// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueFire from 'vuefire'
import App from './App'
import router from './router'
import Navbar from '@/components/Navbar'
import Filtri from '@/components/Filtri'
import { Utility } from '@/components/Utility'
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import solid from '@fortawesome/fontawesome-free-solid'
import VueSweetalert2 from 'vue-sweetalert2'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { jStore } from './store/jestionaleStore.js'


Vue.use(VueSweetalert2)
Vue.use(VueLodash, lodash)
Vue.use(VueFire)
Vue.use(require('vue-shortkey'))

fontawesome.config.searchPseudoElements = true
fontawesome.library.add(solid)
// Use any icon from the Solid style

// NB: IMPORTARE IN QUESTO MODO I COMPONENTI CHE USATO I PUNTATORI  
const Sidebar = () => import('@/components/Sidebar')
const Tendina = () => import('@/components/Tendina')
const Ordine = () => import('@/components/Ordine')
const OrdineOld = () => import('@/components/Ordine_old')
const OrdiniScheletro = () => import('@/components/OrdiniScheletro')
const InserimentoRicambi = () => import('@/components/NewInserimentoRicambi')
const InserimentoListino = () => import('@/components/InserimentoListino')
const Selettore = () => import('@/components/Selettore')
const imageLoader = () => import('@/components/imageLoader')
const sidePanel = () => import('@/components/sidePanel')
const qrCodeScanner = () => import('@/components/qrCodeScanner')


// Richiamo in mixing Utility contenente varie fx da usare globalmente (con attenzione)
Vue.mixin(Utility)
// const isProduction = process.env.NODE_ENV === 'production'
// Before you create app
Vue.config.devtools = true

Vue.component('navbar', Navbar)
Vue.component('filtri', Filtri)
Vue.component('sidebar', Sidebar)
Vue.component('tendina', Tendina)
Vue.component('ordine', Ordine)
Vue.component('ordine-old', OrdineOld)
Vue.component('ordine-scheletro', OrdiniScheletro)
Vue.component('inserimentoRicambi', InserimentoRicambi)
Vue.component('InserimentoListino', InserimentoListino)
Vue.component('selettore', Selettore)
Vue.component('imageLoader', imageLoader)
Vue.component('sidePanel', sidePanel)
Vue.component('qrCodeScanner', qrCodeScanner)

require('../node_modules/animate.css/animate.min.css')
require('./css/dashboard.css')
require('../node_modules/@fortawesome/fontawesome-free-webfonts/css/fontawesome.css')
require('../node_modules/@fortawesome/fontawesome-free-webfonts/css/fa-solid.css')

// creazione bus per comunicazione tra componenti senza grado di parentela
export const EventBus = new Vue()
Vue.config.productionTip = false

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  store: jStore,
  router,
  components: { App },
  template: '<App/>'
})


